import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionService } from '../../Util/Session/session.service';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EmpchangepasswordService {

  constructor(
    private http: HttpClient,
    private session: SessionService,
  ) {
    try {
      environment.API_URL = this.session.GetUserDetails().ApiUrl;
    } catch (e) { }
  }

  Ess_ChangePassword(Detail: any) {
    return this.http.post<any>(environment.API_URL + `Ess_ChangePassword/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }))
  }
}
